<form #form novalidate>
  <!-- TODO: Uncomment this when we use me/permissions  -->
  <!-- <div id="bookingDetailsContainer" class="container absolute top-20 right-0 hiddenDetails w-0 h-[calc(100vh-75px)] overflow-hidden" [ngClass]="{ 'openDetails md:w-[47%] 2xl:w-[35%]': booking && roleService.permissions['RESERVATION']['READ'], 'openDetails md:w-[68%] 2xl:w-[54%]': booking && expanded && roleService.permissions['RESERVATION']['READ']}"> -->
  <div id="bookingDetailsContainer" class="container absolute top-20 right-0 hiddenDetails w-0 h-[calc(100vh-75px)] overflow-hidden flex flex-col" [ngClass]="{ 'openDetails md:w-[50%] 2xl:w-[43%]': booking, 'openDetails md:w-[73%] 2xl:w-[63%]': booking && expanded}">
    @if (booking) {
      <section class="bg-primary-purple-light-2 h-14 mt-4 flex items-center">
        @if (booking.id) {
          <div class="flex justify-center items-center">
            <h1 class="ml-8 text-xl font-semibold truncate">
              {{ literalService.get("bookings.name", true) }}
            </h1>
            <img [src]="getTicketProperties().src" [alt]="getTicketProperties().alt" class="h-6 w-6 mt-1 ml-2" [position]="TooltipPosition.DYNAMIC" [tooltip]="getTicketProperties().tooltip" (click)="openModal('status')" />
            @if (booking.price !== null && booking.price !== undefined) {
              <span class="font-semibold text-[18px] ml-1" [ngClass]="getTicketPriceColor()">{{ booking.price }}€</span>
            }
          </div>
          <section id="actions" class="flex ml-auto mr-8">
            <div class="flex items-center justify-center mr-2">
              <app-active-tickets-chip [tickets]="tripActiveTickets" [compact]="true" (ticketSelected)="openActiveTicket($event)" />
            </div>
            @if (expanded && canCreateTicket) {
              <div class="flex items-center justify-center content-image mr-2">
                <app-new-ticket-button class="mr-4 ml-4" [iconOnly]="true" (create)="createTicket()" />
              </div>
            }
            <div class="flex items-center justify-center content-image mr-2" (click)="showCreateFavouriteModal()">
              <img
                [tooltip]="literalService.get('bookings.tooltips.favorite', true)"
                [position]="TooltipPosition.BELOW"
                [src]="images.booking.actions.favorite"
                alt="favorite"
                class="h-6 w-6 mr-4 ml-4 cursor-pointer"
              />
            </div>
            @if (!booking.cancelled) {
              <a class="flex items-center justify-center content-image mr-2" (click)="goToTrip(booking.tripId); $event.preventDefault()" href="{{ `/trips/${booking.tripId}` }}">
                <img
                  [tooltip]="literalService.get('bookings.tooltips.trip', true)"
                  [position]="TooltipPosition.BELOW"
                  [src]="images.booking.actions.trip"
                  alt="trip" 
                  class="h-6 w-6 mr-4 ml-4 cursor-pointer"
                />            
              </a>
            }
            <a class="flex items-center justify-center content-image mr-2" (click)="goToUser(booking.userId, booking.userType); $event.preventDefault()" href="{{ `/users/${booking.userId}` }}">
              <img
                [tooltip]="literalService.get('bookings.tooltips.user', true)"
                [position]="TooltipPosition.BELOW"
                [src]="images.booking.actions.user"
                alt="user"
                class="h-6 w-6 mr-4 ml-4 cursor-pointer"
              />
            </a>
            <!--div class="flex items-center justify-center content-image mr-2">
              <img
                [tooltip]="literalService.get('bookings.tooltips.open', true)"
                [position]="TooltipPosition.BELOW"
                [src]="images.booking.actions.open"
                alt="open"
                class="h-6 w-6 mr-4 ml-4 cursor-pointer"
              />
            </div-->
            <!-- TODO: Uncomment this when we use me/permissions  -->
            <!-- @if (expanded && roleService.permissions['RESERVATION']['UPDATE']) { -->
            @if (expanded) {
              <!--div
                class="flex items-center justify-center content-image mr-2"
                (click)="editBooking.emit(booking)"
              >
                <img
                  [tooltip]="literalService.get('bookings.tooltips.edit', true)"
                  [position]="TooltipPosition.BELOW"
                  [src]="images.booking.actions.edit"
                  alt="edit"
                  class="h-6 w-6 mr-4 ml-4 cursor-pointer"
                />

              </div-->
              @if (!booking.cancelled) {
                <div
                  class="flex items-center justify-center content-image mr-2"
                  (click)="showSetFaultModal()"
                >
                  <img
                    [tooltip]="booking.missed ? literalService.get('bookings.tooltips.unMarkAsAFault', true) : literalService.get('bookings.tooltips.markAsAFault', true)"
                    [position]="TooltipPosition.BELOW"
                    [src]="images.booking.actions.missed"
                    alt="missed"
                    class="h-6 w-6 mr-4 ml-4 cursor-pointer"
                    [ngClass]="{'filter-secondary-red': booking.missed }"
                  />
                </div>
                @if (booking.cancellable) {
                  <div
                    class="flex items-center justify-center content-image mr-2"
                    (click)="deleteBooking.emit()"
                  >
                    <img
                      [tooltip]="literalService.get('bookings.tooltips.delete', true)"
                      [position]="TooltipPosition.BELOW"
                      [src]="images.booking.actions.delete"
                      alt="delete"
                      class="h-6 w-6 mr-4 ml-4 cursor-pointer"
                    />
                  </div>
                }
              }
            }
            <div class="flex items-center justify-center cursor-pointer mr-2" (click)="close()">
              <img
                [tooltip]="literalService.get('closeWindow', true)"
                [position]="TooltipPosition.BELOW"
                [src]="images.close"
                alt="closeDetails"
                class="h-6 w-6"
              />
            </div>
          </section>
        }
      </section>
      <section class="pt-8 ml-8 pr-20 pb-36 h-full items-center scrollable-content">
        <div class="grid grid-rows-6 grid-flow-col" [ngClass]="{ 'grid-rows-6': booking }">
          @for (element of bookingForm; track $index) {
            <article>
              @if (expanded ? true : !element.expanded) {
                @if (element.edit) {
                  <app-editable-detail [data]="element" [value]="element.value" [isHoveringOriginDestinationDetail]="isHoveringOriginDestinationDetail" (action)="openModal(element.edit.valueToChange)" (setIsHoveringOriginDestination)="setIsHoveringOriginDestinationDetail($event)" />
                } @else {
                  <div [ngClass]="{'mt-5 mb-5': booking.cancelled}">
                    <app-detail [data]="element" [value]="element.value" />
                  </div>
                }
              }
            </article>
          }
          </div>
        <div class="flex justify-end">
          <button id="viewMap" type="button" class="flex items-center font-semibold mb-5" (click)="openInFullMap.emit(booking)">
            <img  [src]="images.world" alt="viewMap" class="h-5 w-5 cursor-pointer" />
            {{ literalService.get('bookings.data.viewMap', true) }}
          </button>
        </div>
        @if (booking && !edit && !newBooking) {
          <div class="flex text-right justify-end items-end" [ngClass]="{'mr-10': booking.cancelled}">
            <div class="text-right mt-5">
              @if (booking.creatorName || booking.createdAt) {
                  <p class="changelog text-primary-purple-light font-light text-sm">{{ literalService.get('created', true) }}
                      @if (booking.creatorName) {
                          <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ booking.creatorName }}</span>
                      }
                      {{ literalService.get('at') }} {{ utilsService.convertDate(booking.createdAt) | date: 'dd/MM/yyyy HH:mm' }}
                  </p>
              }
              @if (booking.modifierName || booking.lastModifiedAt) {
                <p class="changelog text-primary-purple-light font-light text-sm">{{ !booking.cancelled  ? literalService.get('lastModification', true) : literalService.get('cancellation', true)}}
                    @if (booking.modifierName) {
                        <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ booking.modifierName }}</span>
                    }
                    {{ literalService.get('at') }} {{ utilsService.convertDate(booking.lastModifiedAt) | date: 'dd/MM/yyyy HH:mm' }}
                </p>                                            
              }
            </div>
            @if (booking.cancellationComment) {
              <div class="flex flex-row ml-1">
                <label class ="text-primary-purple-light font-light text-sm self-end">{{'...'}}&nbsp;</label>
                <img [src]="images.plus" class="h-5 w-5 filter-primary-purple-light ml-2" [tooltip]="cancellationReason + booking.cancellationComment">
              </div>
            }
          </div>
        }
      </section>
      <section class="flex items-center absolute right-5 top-0 bottom-0">
        <img alt="arrowToExpand" [src]="images.arrowLeft" class="h-5 w-5 cursor-pointer expand" [ngClass]="{ actionRotateArrowOpen: !expanded, actionRotateArrowClose: expanded }" (click)="expanded = !expanded" />
      </section>
    }
  </div>
  <app-modal-change-booking-kms [id]="'changeKms'" [booking]="booking" [modal]="changeKms" [hidden]="false" (action)="submitBookingKmsEdit($event)" (onExceededLimit)="handleExceedingKmsLimit($event)"/>
  <app-modal-change-booking-availability [id]="'changeAvailability'" [booking]="bookingCopy" [modal]="changeAvailability" [routes]="routesElement" [availabilities]="availabilitiesElement" [loadingAvailabilities]="loadingAvailabilities" [hidden]="false" [needsConfirmation]="checkIfBookingNeedsEditConfirmation()"  (action)="submitBookingEdit($event)" (update)="getRouteAvailabilities($event)" />
  <app-modal-change-booking-origin-destination [id]="'changeOriginDestination'" [booking]="bookingCopy" [modal]="changeOriginDestination" [originElement]="originElement" [destinationElement]="destinationElement" [hidden]="false" [updating]="updatingOriginDestination" [needsConfirmation]="checkIfBookingNeedsEditConfirmation()" (action)="submitBookingEdit($event)" (onExceededLimit)="handleExceedingKmsLimit($event)" />
  <app-modal-change-booking-seats [id]="'changeSeats-detail'" [booking]="bookingCopy" [modal]="changeSeats" [hidden]="false" [editable]="editable" [needsConfirmation]="checkIfBookingNeedsEditConfirmation()" (action)="submitBookingEdit($event)" (report)="markSeatAsFault.emit($event)" />
  <app-modal-create-favourite [id]="'createFavouriteFromDetail'" [modal]="createFavouriteModal" [title]="literalService.get('bookings.actions.createFavourite.title')" [text]="literalService.get('bookings.actions.createFavourite.text')" [hidden]="!createFavouriteShowed" [creating]="creatingFavourite" (action)="createFavourite($event)"></app-modal-create-favourite>
  <app-modal-confirmation [id]="'setFault'" [modal]="setFaultModal" [shown]="setFaultShowed" [title]="literalService.get('bookings.actions.setFault.title')" [text]="booking && booking.missed ? literalService.get('bookings.actions.setFault.unFault') : literalService.get('bookings.actions.setFault.fault')" [hidden]="!setFaultShowed" (action)="markAsAFault.emit(); setFaultModal.toggle();"></app-modal-confirmation>
  <app-modal-exceeding-km-limit [id]="'exceedingKmLimitEdit'" [modal]="exceedingKmLimitModal" [img]="images.booking.warning" [title]="literalService.get('bookings.kmLimitExceeded.title', true)" [text]="literalService.get('bookings.kmLimitExceeded.text', true)" [buttonText]="literalService.get('bookings.actions.updateKms.updateAnyway', true)" [hidden]="!exceedingKmLimitShowed" [booking]="bookingCopy" [kmDone]="kmsTravelled" [kmLimit]="maxKmsPerMonth" (action)="submitEdit($event)" (close)="closeExceedingKm()"></app-modal-exceeding-km-limit>
</form>
